
import './App.css';
import { Navbar } from './component/Navbar';
import { HeroSection } from './component/HeroSection';
import { ModelSection } from './component/ModelSection';
import { ChannelsSection } from './component/ChannelsSection';
import { ProgramSection } from './component/ProgramSection';
import { CompanySection } from './component/CompanySection';
import { PartnerSection } from './component/PartnerSection';
import { Footer } from './component/Footer';

function App() {

  return (
    <>
      <Navbar />
      <HeroSection/>
      <ModelSection />
      <ChannelsSection />
      <ProgramSection />
      <CompanySection />
      <PartnerSection />
      <Footer />
    </>
  );

}

export default App;
